import React from 'react';
import {
    BLACK_FRIDAY_COUNTDOWN_END_DATE,
    BLACK_FRIDAY_COUNTDOWN_EXTENDED_DATE,
    CYBER_WEEK_COUNTDOWN_END_DATE,
    HOLIDAY_COUNTDOWN_START_DATE,
    HOLIDAY_COUNTDOWN_END_DATE,
    HOLIDAY_EXTENDED_COUNTDOWN_END_DATE,
    LIFETIME_SMOOTH_COUNTDOWN_START_DATE,
    LIFETIME_SMOOTH_COUNTDOWN_END_DATE,
} from '../../../utils';

export const countdownPeriods = [
    {
        id: 'black-friday',
        startDate: null, // null means no start restriction
        endDate: BLACK_FRIDAY_COUNTDOWN_END_DATE,
        text: (
            <>
                <strong>$500 off + 50% off + Free Small Area</strong> with purchase.{' '}
                <br className="d-block d-lg-none" />
                Black Friday Sale ends in
            </>
        ),
    },
    {
        id: 'black-friday-extended',
        startDate: BLACK_FRIDAY_COUNTDOWN_END_DATE,
        endDate: BLACK_FRIDAY_COUNTDOWN_EXTENDED_DATE,
        text: (
            <>
                <strong>$500 off + 50% off + Free Small Area</strong> with purchase.{' '}
                <br className="d-block d-lg-none" />
                Black Friday Sale extended for
            </>
        ),
    },
    {
        id: 'cyber-week',
        startDate: BLACK_FRIDAY_COUNTDOWN_EXTENDED_DATE,
        endDate: CYBER_WEEK_COUNTDOWN_END_DATE,
        text: (
            <>
                Get our <strong>best deal ever: 65% OFF Every Body Area.</strong> <br className="d-block d-lg-none" />
                Cyber Week Sale ends in
            </>
        ),
    },
    {
        id: 'holiday',
        startDate: HOLIDAY_COUNTDOWN_START_DATE,
        endDate: HOLIDAY_COUNTDOWN_END_DATE,
        text: <strong>BEST DEAL EVER: 65% OFF ENDS DEC. 24</strong>,
    },
    {
        id: 'holiday-extended',
        startDate: HOLIDAY_COUNTDOWN_END_DATE,
        endDate: HOLIDAY_EXTENDED_COUNTDOWN_END_DATE,
        text: <strong>BEST DEAL EVER EXTENDED: 65% OFF ENDS DEC. 31</strong>,
    },
    {
        id: 'lifetime-smooth',
        startDate: LIFETIME_SMOOTH_COUNTDOWN_START_DATE,
        endDate: LIFETIME_SMOOTH_COUNTDOWN_END_DATE,
        text: <strong>LIFETIME OF SMOOTH EVENT: 65% OFF ENDS JAN. 31</strong>,
    },
];

// Get the currently active countdown period based on the current date
export const getActiveCountdownPeriod = (currentDate = new Date()) => {
    return countdownPeriods.find((period) => {
        const afterStart = !period.startDate || currentDate >= period.startDate;
        const beforeEnd = currentDate < period.endDate;
        return afterStart && beforeEnd;
    });
};
